<template lang="pug">
  div
    div( class='shrunken-box')
      h3 Contact Us
      p Call us at (617) 505-6868 or use the form below to let us know what you're looking for and one of our agents will get back to you.
    el-form( ref="leadInsertForm" size='small' class='lead-insert-form' label-width='10em' label-position='right')
      //el-form-item( label="* Bedrooms" prop="beds" :error='(!this.validate || (this.beds && this.beds.length > 0)) ? "" : "Please select at least one."')
      div( class="form-flex" )
        div( class="form-group" )
          el-form-item( label="* First Name" prop='firstName' :error='(this.validate && (this.firstName ==  null || this.firstName == "")) ? "Please provide a first name." : ""')
            el-input( placeholder='First name...' v-model="firstName")
          el-form-item( label="Last Name" prop='lastName')
            el-input( placeholder='Last name...' v-model="lastName")
          el-form-item( ref='phoneField' label="* Phone Number" prop='phone' :error='(this.validate && (this.phone ==  null || this.phone.length < 10)) ? "Please provide a valid phone number." : ""')
            el-input( placeholder='Phone Number...' v-model="phone")
          el-form-item( label="Email Address" prop='email')
            el-input( placeholder='Email Address...' v-model="email")
          el-form-item( label="Pets" prop="pets" )
            el-checkbox-group( v-model="pets" )
              el-checkbox-button( label="cat" ) Cat
              el-checkbox-button( label="dog" ) Dog
          el-form-item( label="Students" prop='students' label-position='top')
            el-checkbox-group( v-model="students" )
              el-checkbox-button( label="undergrad" ) Undergrad
              el-checkbox-button( label="grad" ) Graduate
        div( class="form-group" )
          el-form-item( label="* Bedrooms" prop="beds" :error='(this.validate && this.beds.length < 1) ? "Please select at least one." : ""')
            el-select( v-model="beds" multiple placeholder="Any Number of Bedrooms" )
              el-option(
                  v-for="item in bedOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              )
          el-form-item( label="* Max Rent" prop="maxRent" :error='(this.validate && this.maxRent <=  0) ? "Must be more than 0." : ""')
            el-input-number( v-model="maxRent" :step="100" placeholder="Max Rent...")
          el-form-item( label="* Move-In Date" prop="availFrom" :error='(this.validate && this.availFrom ==  null) ? "When do you need to move in?" : ""')
            el-date-picker( v-model="availFrom" type="date" placeholder="Target Or Earliest Date..." format="MMM d" :picker-options="dateOptions" )
          el-form-item( label="to" prop="availTo" )
            el-date-picker( v-model="availTo" type="date" placeholder="Same Day As Earliest..." format="MMM d" :picker-options="dateOptions" )
          el-form-item( label="Locations" prop="locations" )
            el-select( v-model="locations" multiple filterable placeholder="Select or describe in notes." )
              el-option-group(label="Most Common Choices")
                el-option(key="Boston:Allston" label="Boston - Allston" value="Boston:Allston")
                el-option(key="Boston:Brighton" label="Boston - Brighton" value="Boston:Brighton")
                el-option(key="Boston:Jamaica Plain" label="Boston - Jamaica Plain" value="Boston:Jamaica Plain")
              el-option-group(
                v-for="city in neighborhoods"
                :key="city.Name[0]"
                :label="city.Name[0]"
              )
              
                el-option(
                  v-for="neighborhood in city.Neighborhood"
                  :key="city.Name[0] + ':' + neighborhood"
                  :label="neighborhood"
                  :value="city.Name[0] + ':' + neighborhood"
                )
          el-form-item( label="Bathrooms" prop='baths')
            el-select( v-model="baths" multiple placeholder="Any Number of Bathrooms" )
              el-option(
                  v-for="item in bathOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              )
      el-form-item( label="More Information" prop='notes' label-position='top' label-width="auto")
        el-input( type='textarea' rows='8' placeholder='Tell us a bit more about who you are and what you\'re looking for.' v-model="notes")
      //el-alert( v-if='!this.validated' title='Missing some required information, please check above.' type='error' show-icon)
      div( id='form-favorites')
        p() Listings you've marked as favorites will be sent to our agents.  We can use these to help get a feel for what you're looking for!
        h5( v-if='this.favoriteListings.length > 0' ) Your favorites being sent: 
        ul( v-if='this.favoriteListings.length > 0') 
          li( v-for='favorite in this.favoriteListings' ) {{favorite.StreetNumber}} {{favorite.StreetName}}
        el-alert( v-if='this.alertMessage' :title='this.alertMessage' :type='this.alertType' effect='dark' show-icon center )
      el-button( type="primary" @click="submitForm" size="medium" v-bind:loading='loading') Submit
</template>

<script>
import { getNeighborhoods, getMonthShortcuts } from "../api/listings"
import { addLead } from '../api/leads'
import { mapState } from 'vuex'

export default {
  metaInfo: {
    title: 'Contact Us | Upright Realty',
    meta: [
      { name: 'description', content: 'Get in touch with one of our expert agents for the finest real estate service in Boston.  Let us find the perfect apartment!' }
    ]
  },
  data() {
    return{
      validate: false,
      loading: false,
      alertType: 'error',
      alertMessage: '',
      bedOptions: [
        { value: 'studio', label: 'Studio' },
        { value: '1', label: '1' },
        { value: '1.5,1.8', label: '1|2 Split' },
        { value: '2', label: '2' },
        { value: '2.5,2.8', label: '2|3 Split' },
        { value: '3', label: '3' },
        { value: '3.5,3.8', label: '3|4 Split' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' }
      ],
      bathOptions: [
        { value: '1', label: '1' },
        { value: '1.5', label: '1.5' },
        { value: '2', label: '2' },
        { value: '2.5', label: '2.5' },
        { value: '3', label: '3' },
        { value: '3.5', label: '3.5' },
        { value: '4', label: '4' }
      ],
      // rules: {
      //   beds: [
      //     { required: true, message: 'Select at least one.', trigger: 'blur', type: 'array', length:'1' }//,
      //     //{ trigger: 'blur', validator: (rule, value, callback) => {}}
      //   ],
      //   maxRent: [
      //     { required: true, min:0, message: 'Can\'t be negative.', type:'integer', trigger: 'blur'}
      //   ],
      //   email: [
      //     { required: false, message: 'Invalid email address.', trigger: 'blur', type: 'email' }
      //   ]
      // },
      dateOptions: {
        shortcuts: this.getMonthShortcuts()
      },
      neighborhoods: null,
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      students: [],
      notes: null
    }
  },
  
  computed: {
    ...mapState(["favoriteListings"]),
    
    maxRent: {
      get(){ return this.$store.state.maxRent },
      set(value){ this.$store.commit('updateMaxRent', value) }
    },

    beds: {
      get(){ return this.$store.state.beds },
      set(value){ this.$store.commit('updateBeds', value) }
    },

    baths: {
      get(){ return this.$store.state.baths },
      set(value){ this.$store.commit('updateBaths', value) }
    },

    availFrom: {
      get(){ return this.$store.state.availFrom },
      set(value){ this.$store.commit('updateAvailFrom', value) }
    },

    availTo: {
      get(){ return this.$store.state.availTo },
      set(value){ this.$store.commit('updateAvailTo', value) }
    },

    pets: {
      get(){ return this.$store.state.pets },
      set(value){ this.$store.commit('updatePets', value) }
    },

    locations: {
      get(){ return this.$store.state.locations },
      set(value){ this.$store.commit('updateLocations', value) }
    },

    validated: {
      get(){ 
        return this.validate 
          ? this.$refs.leadInsertForm.fields.filter(field => field.validateState == "error").length === 0
          : true;
      }
    }
  },

  methods: {
    getNeighborhoods(){
      getNeighborhoods()
      .then(neighborhoods => {
        this.neighborhoods = neighborhoods;
      })
      .catch(error => {
        this.console.log("Unable to access neighborhood data for search form: " + error);
      });
    },
    getMonthShortcuts(){
      return getMonthShortcuts();
    },

    submitForm(){
      this.validate = true;
      var self = this;
      this.loading = true;
      this.$nextTick().then(function() {
        if (self.validated){
          self.alertMessage = "Submitting your request...";
          self.alertType = "info";
          addLead({
            beds: self.beds,
            baths: self.baths,
            availFrom: self.availFrom,
            availTo: self.availTo,
            maxRent: self.maxRent,
            pets: self.pets,
            locations: self.locations,
            firstName: self.firstName,
            lastName: self.lastName,
            phone: self.phone,
            email: self.email,
            students: self.students,
            notes: self.notes,
            ids: self.favoriteListings.map(favorite => favorite.ID)
          })
          .then(response => {
            self.loading = false;
            if (response.data.status == 200){
              self.alertType = 'warning';
              self.alertMessage = "Your request was submitted successfully.";
            }
            else{
              self.alertType = 'error';
              self.alertMessage = "There was a problem adding your information to our databse, please try again or give us a call!";
            }
          })
          .catch(() => {
            self.loading = false;
            self.alertType = 'error';
            self.alertMessage = "Problem contacting the server, please try again or give us a call!";
          })
        }
        else{
          self.loading = false;
          self.alertType = 'error';
          self.alertMessage = "Missing some required information, please check above.";
        }
      })
    }
  },
  
  mounted(){
    this.getNeighborhoods();
  }
}
</script>

<style scoped lang="scss">
//@import '../_variables';

h3{
  font-weight:900;
  font-size: 1.6em;
  padding-bottom: 0;
  margin-bottom: 3px;
}

p{
  font-size: 1.1em;
  //font-weight: 600;
}

.shrunken-box p{
  margin-top: 0;
}

.shrunken-box{
  // background: mix(white, $color-primary, 95);
  // padding-top: 0px;
  // margin-top: 20px;
}

.el-form{
  padding: 30px; 
  padding-top: 15px;
}

.form-flex{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.form-group{
  width: 350px;
  min-width: 350px;
  max-width: 700px;
  flex: 1 0 350px;
}

.el-select{
  width: 100%;
}

.el-form-item__content, .el-form-item{
  text-align: left;
}

button{
  margin-top: 10px;
  width: 50%;
  background-color: $color-background;
}

.el-button--primary{
  margin-top: 10px;
  background-color: mix(black, $color-primary, 40);
  box-shadow: 1px 1px 2px black;
}

.shrunken-box{
  margin-left: 10%;
  margin-right: 10%;
  //margin-top: 30px;
  //border: 1px solid $color-primary;
  //background-color: mix(white, $color-accent, 80);
  padding: 10px;
  color: mix(black, $color-primary, 30);
  border-radius: 3px;
  //border-bottom: 2px solid $color-primary;

}

#form-favorites h5{
  margin-top: 5px;
  margin-bottom: 5px;
}

#form-favorites ul{
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  justify-content: center;
}

 #form-favorites ul li{
   margin-left: 3px;
   margin-right: 3px;
 }

 #form-favorites li + li::before {
    content: " | ";
}
</style>